// Add your JS customizations here
//gravity forms error handling
jQuery(document).on('gform_post_render', function(event, form_id, current_page){
    // code to trigger on form or form page render
    //Error for form with static labels
  jQuery('.gfield_error > .ginput_container').focusin(function(){
    jQuery(this).parent('li').children('label').show();
    jQuery(this).parent('li').find('.validation_message').hide();
    jQuery(this).parent('li').removeClass('gfield_error');
  });
  console.log('form render');
  toggleFloatLabel('.ginput_container_text');
  toggleFloatLabel('.ginput_container_textarea');
  toggleFloatLabel('.ginput_container_phone');
  toggleFloatLabel('.ginput_container_email');
  toggleFloatLabel('.ginput_container_date');
  toggleFloatLabel('.ginput_container_select');
  //Code for form with floating labels
  jQuery('.ginput_container_text').focusin(function(){
    jQuery(this).parent('div').children('label').addClass('float_label');
  });


  jQuery('.ginput_container_text').focusout(function(){
   toggleFloatLabel(this, 'input');
 });

  jQuery('.ginput_container_email').focusin(function(){
    jQuery(this).parent('div').children('label').addClass('float_label');
  });

  jQuery('.ginput_container_email').focusout(function(){
    toggleFloatLabel(this, 'email');
  });
  jQuery('.ginput_container_select').focusin(function(){
    jQuery(this).parent('div').children('label').addClass('float_label');
  });
  jQuery('.ginput_container_select').focusout(function(){
    toggleFloatLabel(this, 'select');
  });
  jQuery('.ginput_container_date').focusin(function(){
    jQuery(this).parent('div').children('label').addClass('float_label');
  });

  jQuery('.ginput_container_date').focusout(function(){
    toggleFloatLabel(this, 'input');
  });

  jQuery('.ginput_container_textarea').focusin(function(){
    jQuery(this).parent('div').children('label').addClass('float_label');
  });


  jQuery('.ginput_container_textarea').focusout(function(){
   toggleFloatLabel(this, 'textarea');

 });

  jQuery('.ginput_container_phone').focusin(function(){
    jQuery(this).parent('div').children('label').addClass('float_label');
  });


  jQuery('.ginput_container_phone').focusout(function(){
   toggleFloatLabel(this, 'tel');

 });


    //Error handling for form with floating labels
  jQuery('.floating_labels .gfield_error > label').hide();
  jQuery('.floating_labels .gfield_error .validation_message').addClass('validation_message--float');    

});

function toggleFloatLabel(selector, type){
  var containerClass='.ginput_container_text';
  if(typeof type == "undefined" || !type){

    containerClass = selector;
  }
  if(containerClass == '.ginput_container_date'){
    type="input"
  }
  
  if(type=='textarea'){
    containerClass='.ginput_container_textarea';
  }

  if(type=='email'){
    containerClass='.ginput_container_email';
    type="input";
  }

  if(type=='tel'){
    containerClass='.ginput_container_phone';
    type='input';
  }
  if(type=='select'){
    containerClass='.ginput_container_select';
    type='select';
  }
  
  
  jQuery(selector).children(type).each(function(){
    if(!jQuery(this).val() || jQuery(this).val() == "(___) ___-____") {
      jQuery(this).parent(containerClass).parent('div').find('label').removeClass('float_label');
    } else {
      jQuery(this).parent(containerClass).parent('div').find('label').addClass('float_label');
    }
  })

}


// Sticky Header Functionality
window.addEventListener("scroll", function () {
  const header = document.querySelector("header");
  const body = document.body;
  if (header) {
    if (window.scrollY > 50) {
      header.classList.add("sticky");
      const headerHeight = header.offsetHeight;
      body.style.paddingTop = headerHeight + "px";
    } else {
      header.classList.remove("sticky");
      body.style.paddingTop = "0px";
    }
  }
});

// Menu Functionality
const hamburgerBtn = document.querySelector(".hamburger-btn"),
  closeBtn = document.querySelector(".close-btn"),
  mobileHeaderNav = document.querySelector(".mobile-header-nav");

if (hamburgerBtn && closeBtn && mobileHeaderNav) {
  const toggleMenu = (show) => {
    mobileHeaderNav.classList.toggle("d-block", show);
  };

  hamburgerBtn.addEventListener("click", () => toggleMenu(true));
  closeBtn.addEventListener("click", () => toggleMenu(false));
}


document.addEventListener('DOMContentLoaded', function () {
  const serviceArea = document.querySelector('.service-areas');
  const header = document.querySelector('.service-areas-header');
  const icon = document.querySelector('.service-areas-icon i');

  if (!serviceArea || !header || !icon) return;

  header.addEventListener('click', function () {
    serviceArea.classList.toggle('active');

    if (serviceArea.classList.contains('active')) {
      icon.classList.remove('icon-plus');
      icon.classList.add('icon-minus1');
    } else {
      icon.classList.remove('icon-minus1');
      icon.classList.add('icon-plus');
    }
  });
});
